'use client';

import { StoryblokReactComponent } from '@/storyblok/components/componentsMap';
import { FooterButtonStoryblok } from '@/types/types-storyblok';

export const CookieFooterButton: StoryblokReactComponent<FooterButtonStoryblok> = ({ component: link }) => {
  return (
    <button
      className="focus:text-text-body hover:text-text-body transition-colors text-sm"
      onClick={() => {
        if (window.CookieConsent) {
          window.CookieConsent?.show();
        } else {
          window.alert('I Cookie non sono abilitati in questo browser');
        }
      }}
    >
      {link.title}
    </button>
  );
};
